<template>
  <v-container>
    <v-row>
      <main-header-plat-a-pat />
    </v-row>
    <v-col class="mt-8 mb-4">
      <strong class="d-flex primary--text justify-center text-subtitle-1">MI CUENTA</strong>
    </v-col>
    <v-row class="d-flex justify-center fluid flex-sm-wrap flex-lg-nowrap">
      <v-col>
        <v-card-pro-account-form
          :schemaForm="schema.schemaForm"
          :modelForm="modelForm"
          :cardProAccount1="schema.cardProAccount1" 
          :dialogAccountPin="schema.dialogAccountPin"
          :dialogAccountPass="schema.dialogAccountPass"
          :dialogAccountDel="schema.dialogAccountDel"
          :dialogAccountPinDel="schema.dialogAccountPinDel"
          :delAccount="delAccount"
        />
      </v-col>
    </v-row>
    <v-snack-bar :snackbar="snackbar" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatAPat from '@/components/includes/MainHeaderPlatAPat.vue';
import VCardProAccountForm from '@/components/base/VCardProAccountForm.vue';
// import VCardProAccountDevice from '@/components/base/VCardProAccountDevice.vue'
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'PatAccountPage',
  components: {
    MainHeaderPlatAPat,
    VCardProAccountForm,
    // VCardProAccountDevice,
    VSnackBar,
  },
  data() {
    return {
      snackbar: {}
    };
  },
  mounted() {
    this.loadSchema();
    this.loadModelForm();
  },
  computed: {
    ...mapGetters('patAccountPage', ['schema', 'modelForm', 'statusPat']),
  },
  methods: {
    ...mapActions('patAccountPage', ['loadSchema', 'loadModelForm']),

    async delAccount() {
      let model = {};
      model.delAccount = true;

      this.$store.dispatch('patAccountPage/delAccount', model).then(
        () => {
          this.snackbarOpen();
        },
        () => {
          this.snackbarOpen();
        }
      );
    },
    snackbarOpen() {
      this.snackbar.visible = false;
      if (this.statusPat === 'success') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackOk;
        this.outlog();
      } else if (this.statusDel === true) {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackOkRemoved;
        this.outlog();
      } else if (this.status === 'error') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackError;
        this.reload();
      }
    },
    reload() {
      this.loadSchema();
      this.loadModelForm();
    },
    outlog() {
      let outlog = '/';
      this.$router.push(outlog);
    },
  },
};
</script>
